(function () {
  const reveal = () => {
    const els = document.querySelectorAll('.amure-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach((el) => io.observe(el));
  };

  const carousels = () => {
    document.querySelectorAll('[data-amure-carousel]').forEach((root) => {
      if (root.dataset.amureBound === 'true') return;
      root.dataset.amureBound = 'true';

      const track = root.querySelector('.amure-carousel__track');
      const prev = root.querySelector('[data-amure-prev]');
      const next = root.querySelector('[data-amure-next]');
      if (!track) return;

      const amount = () => {
        const card = track.querySelector('.amure-card-wrap') || track.querySelector('.amure-card');
        return card ? card.getBoundingClientRect().width + 20 : 320;
      };

      if (prev) {
        prev.addEventListener('click', () => {
          track.scrollBy({ left: -amount(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          track.scrollBy({ left: amount(), behavior: 'smooth' });
        });
      }
    });
  };

  const faqs = () => {
    document.querySelectorAll('[data-amure-faq]').forEach((list) => {
      list.querySelectorAll('.amure-faq__question').forEach((btn) => {
        if (btn.dataset.amureBound === 'true') return;
        btn.dataset.amureBound = 'true';

        btn.addEventListener('click', () => {
          const item = btn.closest('.amure-faq__item');
          if (!item) return;
          const open = item.classList.contains('is-open');

          list.querySelectorAll('.amure-faq__item.is-open').forEach((el) => {
            el.classList.remove('is-open');
            const q = el.querySelector('.amure-faq__question');
            if (q) q.setAttribute('aria-expanded', 'false');
          });

          if (!open) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  };

  const header = () => {
    const wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;

    const onScroll = () => {
      wrapper.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const wishlist = () => {
    const KEY = 'amure-wishlist';

    const read = () => {
      try {
        const items = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(items) ? items : [];
      } catch (e) {
        return [];
      }
    };

    const write = (items) => localStorage.setItem(KEY, JSON.stringify(items));

    const escapeHtml = (value) => {
      const el = document.createElement('div');
      el.textContent = value || '';
      return el.innerHTML;
    };

    const setOpen = (open) => {
      const drawer = document.querySelector('[data-amure-wishlist-drawer]');
      if (!drawer) return;
      drawer.hidden = !open;
      document.documentElement.classList.toggle('amure-wishlist-open', open);
      document.querySelectorAll('[data-amure-wishlist-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    };

    const render = () => {
      const items = read();
      const drawer = document.querySelector('[data-amure-wishlist-drawer]');
      const list = document.querySelector('[data-amure-wishlist-list]');
      const empty = document.querySelector('[data-amure-wishlist-empty]');
      const clearBtn = document.querySelector('[data-amure-wishlist-clear]');
      const removeLabel = drawer ? drawer.getAttribute('data-remove-label') || 'Remove' : 'Remove';

      document.querySelectorAll('[data-amure-wishlist]').forEach((btn) => {
        const saved = items.some((item) => item.handle === btn.dataset.handle);
        btn.classList.toggle('is-saved', saved);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      });

      document.querySelectorAll('[data-amure-wishlist-count]').forEach((el) => {
        const span = el.querySelector('span') || el;
        span.textContent = String(items.length);
        if (items.length) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });

      document.querySelectorAll('[data-amure-wishlist-open]').forEach((btn) => {
        btn.classList.toggle('has-items', items.length > 0);
      });

      if (clearBtn) {
        if (items.length) {
          clearBtn.removeAttribute('hidden');
        } else {
          clearBtn.setAttribute('hidden', '');
        }
      }

      if (!list || !empty) return;

      if (!items.length) {
        empty.hidden = false;
        list.hidden = true;
        list.innerHTML = '';
        return;
      }

      empty.hidden = true;
      list.hidden = false;
      list.innerHTML = items
        .map((item) => {
          const image = item.image
            ? `<div class="amure-wishlist-item__media"><img src="${escapeHtml(item.image)}" alt="" width="72" height="88" loading="lazy"></div>`
            : `<div class="amure-wishlist-item__media"></div>`;
          return `<article class="amure-wishlist-item">
            <a href="${escapeHtml(item.url || '#')}">${image}</a>
            <div class="amure-wishlist-item__copy">
              <p class="amure-wishlist-item__title"><a href="${escapeHtml(item.url || '#')}">${escapeHtml(item.title)}</a></p>
              <p class="amure-wishlist-item__price">${escapeHtml(item.price || '')}</p>
              <button type="button" class="amure-wishlist-item__remove" data-amure-wishlist-remove="${escapeHtml(item.handle)}">${escapeHtml(removeLabel)}</button>
            </div>
          </article>`;
        })
        .join('');
    };

    const clearAll = () => {
      write([]);
      render();
    };

    const toggleItem = (data, options = {}) => {
      const handle = data.handle || '';
      if (!handle) return;
      const items = read();
      const index = items.findIndex((item) => item.handle === handle);
      const removing = index > -1;
      if (removing) {
        items.splice(index, 1);
      } else {
        items.unshift({
          handle,
          url: data.url || '',
          title: data.title || '',
          image: data.image || '',
          price: data.price || '',
        });
      }
      write(items);
      render();
      if (!removing && options.open !== false) setOpen(true);
    };

    if (document.documentElement.dataset.amureWishlistBound !== 'true') {
      document.documentElement.dataset.amureWishlistBound = 'true';

      document.addEventListener('click', (event) => {
        const saveBtn = event.target.closest('[data-amure-wishlist]');
        if (saveBtn) {
          event.preventDefault();
          event.stopPropagation();
          toggleItem({
            handle: saveBtn.getAttribute('data-handle') || '',
            url: saveBtn.getAttribute('data-url') || '',
            title: saveBtn.getAttribute('data-title') || '',
            image: saveBtn.getAttribute('data-image') || '',
            price: saveBtn.getAttribute('data-price') || '',
          });
          return;
        }

        if (event.target.closest('[data-amure-wishlist-open]')) {
          event.preventDefault();
          setOpen(true);
          return;
        }

        if (event.target.closest('[data-amure-wishlist-close]')) {
          event.preventDefault();
          setOpen(false);
          return;
        }

        const removeBtn = event.target.closest('[data-amure-wishlist-remove]');
        if (removeBtn) {
          event.preventDefault();
          toggleItem({ handle: removeBtn.getAttribute('data-amure-wishlist-remove') });
          return;
        }

        if (event.target.closest('[data-amure-wishlist-clear]')) {
          event.preventDefault();
          clearAll();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setOpen(false);
      });
    }

    render();
  };

  const hotspots = () => {
    document.querySelectorAll('.amure-hotspot-wrap').forEach((wrap) => {
      if (wrap.dataset.amureBound === 'true') return;
      wrap.dataset.amureBound = 'true';

      wrap.addEventListener('click', (event) => {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        if (event.target.closest('.amure-hotspot-card')) return;
        const wasOpen = wrap.classList.contains('is-open');
        document.querySelectorAll('.amure-hotspot-wrap.is-open').forEach((el) => {
          el.classList.remove('is-open');
        });
        if (!wasOpen) wrap.classList.add('is-open');
      });
    });
  };

  const backTop = () => {
    const btn = document.querySelector('[data-amure-back-top]');
    if (!btn || btn.dataset.amureBound === 'true') return;
    btn.dataset.amureBound = 'true';

    const sync = () => {
      const show = window.scrollY > 480;
      btn.hidden = !show;
    };

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    sync();
    window.addEventListener('scroll', sync, { passive: true });
  };

  const init = () => {
    reveal();
    carousels();
    faqs();
    header();
    wishlist();
    hotspots();
    backTop();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-amure-cookie-settings]');
    if (!trigger) return;
    event.preventDefault();
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.showPreferences === 'function') {
      privacy.showPreferences();
      return;
    }
    if (privacy && privacy.overlay && typeof privacy.overlay.show === 'function') {
      privacy.overlay.show();
      return;
    }
    const manage = document.querySelector('[data-action="manage-cookies"], #shopify-pc__banner button');
    if (manage) manage.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
